// extracted by mini-css-extract-plugin
module.exports = {"table":"AssignTaskOperatorsModal_table__Dnh_M","header":"AssignTaskOperatorsModal_header__3i6Yc"};